import React from 'react'
import Person from '../components/Person'

const content = [
  {
    type: 'text',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,'
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'das-project-foto-lisa9_yaoonu',
    alt: 'dasProject Foto Lisa',
    aspectRatio: 0.666
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'das-project-foto-lisa11_appq1t',
    alt: 'dasProject Foto Lisa',
    aspectRatio: 0.666
  },
  {
    type: 'group',
    position: 'left',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et',
    firstImg: {
      id: 'das-project-foto-lisa7_zkevte',
      alt: 'dasProject Foto Lisa',
      aspectRatio: 1.5
    },
    secondImg: {
      id: 'das-project-foto-lisa8_kxemjq',
      alt: 'dasProject Foto Lisa',
      aspectRatio: 1.5
    }
  },
  {
    type: 'text',
    text: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren,'
  },
  {
    type: 'img-full',
    position: 'right',
    imgId: 'das-project-foto-lisa11_appq1t',
    alt: 'dasProject Foto Lisa',
    aspectRatio: 0.666
  }
]

const color = 'cornflowerblue'

export default class ReactComponent extends React.Component {
  constructor(){
    super()
    this.state = {color: 'cornflowerblue'}
  }

  render () {
    return (
      <div>
        <Person content={content} color={this.state.color} name='Lisa' next={5} previous={3}/>
      </div>
    )
  }
}

exports.data = {
  color: 'cornflowerblue',
  number: 5
}



// WEBPACK FOOTER //
// ./lisa.js